import { VIEW_SUPPLY_REQUEST, VIEW_SUPPLY_SUCCESS, VIEW_SUPPLY_ERROR, RESET_VIEW_SUPPLY } from "../actions/viewSupply"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const viewSupply = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_SUPPLY_REQUEST:
            return {
                ...state,
                loading: true
            }

        case VIEW_SUPPLY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case VIEW_SUPPLY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case RESET_VIEW_SUPPLY:
            return {
                ...state,
                loading: false,
                data: null,
                error: null
            }
        default:
            return state;
    }
}

export default viewSupply
